 import ThemeInfinity from './infinity/Theme';
 import ThemeTrevoSport from './trevosport/Theme';
 import ThemeDefault from './default/Theme';
 class Theme {
  constructor (data = {}) {
      this.themes = {
        "^(.*).infinitybet(.*)$": ThemeInfinity,
        "^(.*).trevosport(.*)$": ThemeTrevoSport
      } 
  }

  getTheme(origin) {
    for (let i in this.themes) {
      if (new RegExp(i).test(origin)) {
        return this.themes[i];
      }
    }

    return ThemeDefault;
  }
 }

 const theme = new Theme();

 export default theme;